export default{
    msg:'',
    editar:{},
    lista:'',
    listaevento:''
}